<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #f0fdf4; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">post_add</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Registrar Referencia (Operador)</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Quema una referencia en el banco elegido para que ningún cliente pueda usarla.</p>
    </div>
  </div>

  <!-- Info card -->
  <div style="margin: 16px 24px; padding: 14px 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div style="display: flex; align-items: flex-start; gap: 8px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a; margin-top: 1px;">info</mat-icon>
      <div style="font-size: 0.82rem; color: #1e5a3f; line-height: 1.5;">
        Si existe una carga <strong>PENDING</strong> del cliente con la misma referencia y monto en el banco elegido, se aprobará automáticamente
        (transparente para el cliente). Si no existe, queda registrada en la cuenta interna del banco sin afectar saldos.
      </div>
    </div>
  </div>

  <!-- Form -->
  <div style="padding: 0 24px;" *ngIf="form">
    <form [formGroup]="form">
      <!-- Selector de banco / rail (oculto si el modal viene locked a un rail) -->
      <div *ngIf="!lockedRail" style="margin-bottom: 16px;">
        <label style="display: block; font-size: 0.85rem; font-weight: 600; color: #374151; margin-bottom: 8px;">Banco</label>
        <mat-button-toggle-group formControlName="rail" style="display: flex; gap: 0; width: 100%;">
          <mat-button-toggle value="N58" style="flex: 1;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 6px;">account_balance</mat-icon>
            N58
          </mat-button-toggle>
          <mat-button-toggle value="BANCO_PLAZA" style="flex: 1;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 6px;">account_balance</mat-icon>
            Banco Plaza
          </mat-button-toggle>
          <mat-button-toggle value="R4" style="flex: 1;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 6px;">account_balance</mat-icon>
            R4 Conecta
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <!-- Banco fijo: solo lectura, indica el rail al que pertenece la pantalla -->
      <div *ngIf="lockedRail" style="margin-bottom: 16px; display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px;">
        <mat-icon style="color: #1C593D; font-size: 18px; width: 18px; height: 18px;">account_balance</mat-icon>
        <span style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">
          Banco: <strong>{{ railLabel(lockedRail) }}</strong>
        </span>
      </div>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>N&uacute;mero de referencia</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">tag</mat-icon>
        <input matInput formControlName="referencia" placeholder="Ej: 96157086" autocomplete="off" />
        <mat-error *ngIf="form.get('referencia')?.hasError('required')">La referencia es requerida</mat-error>
        <mat-error *ngIf="form.get('referencia')?.hasError('minlength')">M&iacute;nimo 6 caracteres</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Monto (VES)</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">payments</mat-icon>
        <input matInput type="number" step="0.01" min="0.01" formControlName="monto" placeholder="0.00" />
        <mat-error *ngIf="form.get('monto')?.hasError('required')">El monto es requerido</mat-error>
        <mat-error *ngIf="form.get('monto')?.hasError('min')">El monto debe ser mayor a 0</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Precio de compra</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">trending_up</mat-icon>
        <input matInput type="number" step="0.0001" min="0.0001" formControlName="precioCompra" placeholder="Ej: 38.50" />
        <mat-error *ngIf="form.get('precioCompra')?.hasError('required')">El precio de compra es requerido</mat-error>
        <mat-error *ngIf="form.get('precioCompra')?.hasError('min')">El precio debe ser mayor a 0</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Motivo (opcional)</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">notes</mat-icon>
        <input matInput formControlName="motivo" maxlength="255" placeholder="Comentario del operador" />
      </mat-form-field>
    </form>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="registrar()" [disabled]="form.invalid || loading"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="form.invalid || loading ? '0.5' : '1'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
      Registrar
    </button>
  </div>

</div>
